import axios from 'axios';

export const bgPromptTestAPI = async ({ model, systemPrompt, mainPrompt }: any) => {
  try {
    let reqData = JSON.stringify({
      model: model,
      system_prompt: systemPrompt,
      main_prompt: mainPrompt,
    });

    const { data } = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_HOST}/api/sa/bd-prompt-change`,
      data: reqData,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return data;
  } catch (error: any) {
    if (error.response) {
      return error.response.data; // => the response payload
    } else {
      //console.log(error);
    }
  }
};

export const bgDataAPI = async ({ companyUniqueId, companyUrl }: any) => {
  try {
    let reqData = JSON.stringify({
      company_unique_id: companyUniqueId,
      main_site_url: companyUrl,
    });

    const { data } = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_HOST}/api/sa/bd-data`,
      data: reqData,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return data;
  } catch (error: any) {
    if (error.response) {
      return error.response.data; // => the response payload
    } else {
      //console.log(error);
    }
  }
};

export const bgGenerateContextAPI = async ({ companyId }: any) => {
  try {
    let reqData = JSON.stringify({
      companyId: companyId,
    });

    const { data } = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_HOST}/api/sa/generate-context`,
      data: reqData,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return data;
  } catch (error: any) {
    if (error.response) {
      return error.response.data; // => the response payload
    } else {
      //console.log(error);
    }
  }
};

export const chatAPI = async ({ companyUniqueId, question }: any) => {
  try {
    let reqData = JSON.stringify({
      companyId: companyUniqueId,
      userQuery: question,
    });

    const { data } = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_HOST}/api/sa/chat`,
      data: reqData,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return data;
  } catch (error: any) {
    if (error.response) {
      return error.response.data; // => the response payload
    } else {
      //console.log(error);
    }
  }
};

export const bgV2DataAPI = async ({ companyUrl }: any) => {
  try {
    let reqData = JSON.stringify({
      main_site_url: companyUrl,
    });

    const { data } = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_HOST}/api/sa/new-bd-data`,
      data: reqData,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return data;
  } catch (error: any) {
    if (error.response) {
      return error.response.data; // => the response payload
    } else {
      //console.log(error);
    }
  }
};

export const bgSiteImagesAPI = async ({ companyUrl }: any) => {
  try {
    let reqData = JSON.stringify({
      main_site_url: companyUrl,
    });

    const { data } = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_HOST}/api/sa/site-image`,
      data: reqData,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return data;
  } catch (error: any) {
    if (error.response) {
      return error.response.data; // => the response payload
    } else {
      //console.log(error);
    }
  }
};

export const bgRedditAPI = async ({ brand, query, category }: any) => {
  try {
    let reqData = JSON.stringify({
      brands: [{ name: brand, category }],
      queries: [query],
    });

    const { data } = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_HOST}/api/sa/reddit-data`,
      data: reqData,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return data;
  } catch (error: any) {
    if (error.response) {
      return error.response.data; // => the response payload
    } else {
      //console.log(error);
    }
  }
};
